export default __webpack_public_path__ + "static/media/mario-golf-course.6a998ad5.jpg";